import type { NodeEntry } from 'slate';

import type { RenderTextOptions } from './text';
import { renderText } from './text';
import {
  isCrossReferenceElement,
  isInsertInstructionFieldEdit,
  isRemoveInstructionFieldEdit,
  Queries,
} from '../../slate-api';
import type {
  InlineInstructionFieldVariant,
  RenderModelInlineInstructionField,
} from '../../slate-api';
import { parseLink } from '../../util';
import { activeInstructionFieldBackgroundColor } from '../colors';
import type { RenderContext } from '../engine/render-context';

const POINTER_CURSOR_VARIANTS: InlineInstructionFieldVariant[] = ['REF', 'PAGEREF', 'NOTEREF'];

export function renderInlineInstructionField(
  renderContext: RenderContext,
  rMInstructionFieldEntry: NodeEntry<RenderModelInlineInstructionField>,
  options: RenderTextOptions
) {
  const { editor } = renderContext;
  const [rMInstructionField, rMInstructionFieldPath] = rMInstructionFieldEntry;
  const { instruction } = rMInstructionField;
  const suggestedEdits = rMInstructionField.suggestedEdits ?? [];
  const width = Queries.getRMNodeWidthPx(editor, rMInstructionFieldEntry);
  const height = Queries.getRMNodeHeightPx(editor, rMInstructionFieldEntry);
  const isPointer = POINTER_CURSOR_VARIANTS.includes(instruction);

  // Cross reference links
  if (isCrossReferenceElement(rMInstructionField)) {
    const parsedLink = parseLink(rMInstructionField.href);

    if (parsedLink.type === 'bookmark')
      renderContext.drawPDFLink(0, 0, width, height, {
        destination: parsedLink.bookmark,
        linkType: 'bookmark',
      });
  }

  renderContext.renderChildren(rMInstructionFieldEntry, { text: renderText }, {
    ...options,
    customHighlight: renderContext.isSelectionInsideCMNode()
      ? { color: activeInstructionFieldBackgroundColor.toString() }
      : undefined,
    inheritDeleteEdit: suggestedEdits.find(isRemoveInstructionFieldEdit),
    inheritInsertEdit: suggestedEdits.find(isInsertInstructionFieldEdit),
    inlineVoid: {
      caret: 'hidden',
      showText: true,
    },
    overrideCursor: isPointer
      ? {
          cursor: 'pointer',
          key: `${rMInstructionFieldPath}-cursor`,
        }
      : undefined,
  } satisfies RenderTextOptions);
}
